export default {
	install(Vue) {
		// 1. 전역 메소드 또는 속성 추가
		// 4. 인스턴스 메소드 추가
		Vue.prototype.$report = {
			reportMetaData: null,
			initData: function(d) {
				this.reportMetaData = d;
			},
			getMetaList: function(k) {
				console.log(k);
				return this.reportMetaData;
			},
			getMetaData: function(k) {
				if (this.reportMetaData) {
					for (var i = 0; i < this.reportMetaData.length; i++) {
						if (this.reportMetaData[i].contentType === k) {
							return this.reportMetaData[i].contentBody;
						}
					}
				}
				return '';
			},
			getMetaObject: function(kAr) {
				var returnObj = {};
				if (this.reportMetaData && kAr && kAr.length > 0) {
					for (var i = 0; i < this.reportMetaData.length; i++) {
						if (kAr.indexOf(this.reportMetaData[i].contentType) > -1) {
							returnObj[this.reportMetaData[i].contentType] = this.reportMetaData[i].contentBody;
						}
					}
				}
				return returnObj;
			},
			getKeyByMetaList: function(kAr) {
				let returnList = [];
				if (this.reportMetaData && kAr) {
					for (let i = 0; i < this.reportMetaData.length; i++) {
						if (kAr.indexOf(this.reportMetaData[i].contentType) > -1) {
							let data = this.reportMetaData[i].contentBody;
							returnList.push({
								contentBody: data,
							});
						}
					}
				}
				return returnList;
			},
			getMetaObjectList: function(kAr) {
				var returnObjList = [];
				var viewOrder = 0;
				if (this.reportMetaData && kAr && kAr.length > 0) {
					for (let x = 0; x < this.reportMetaData.length; x++) {
						for (let i = 0; i < kAr.length; i++) {
							viewOrder = this.reportMetaData[x].viewOrder;
							if (kAr[i] === this.reportMetaData[x].contentType) {
								if (returnObjList.length <= viewOrder) {
									returnObjList.push({});
									viewOrder = returnObjList.length - 1;
								}
								returnObjList[viewOrder][this.reportMetaData[x].contentType] = this.reportMetaData[x].contentBody;
								viewOrder++;
							}
						}
						viewOrder = 0;
					}
				}
				for (let i = 0; i < kAr.length; i++) {
					for (let j = 0; j < returnObjList.length; j++) {
						let keyList = Object.keys(returnObjList[j]);
						if (keyList.indexOf(kAr[i]) < 0) {
							returnObjList[j][kAr[i]] = '';
						}
					}
				}
				return returnObjList;
			},
			getMetaObjectListMultiple: function(kAr) {
				var returnObjList = [];
				var viewOrder = 0;
				if (this.reportMetaData && kAr && kAr.length > 0) {
					for (let x = 0; x < this.reportMetaData.length; x++) {
						for (let i = 0; i < kAr.length; i++) {
							viewOrder = this.reportMetaData[x].viewOrder;
							if (kAr[i].indexOf(this.reportMetaData[x].contentType) > -1) {
								if (returnObjList.length <= viewOrder) {
									returnObjList.push({});
									viewOrder = returnObjList.length - 1;
								}
								if (
									typeof returnObjList[viewOrder][this.reportMetaData[x].contentType] === 'undefined' ||
									returnObjList[viewOrder][this.reportMetaData[x].contentType] === null
								) {
									returnObjList[viewOrder][this.reportMetaData[x].contentType] = [];
								}
								returnObjList[viewOrder][this.reportMetaData[x].contentType].push(this.reportMetaData[x].contentBody);
							}
						}
						viewOrder = 0;
					}
				}

				for (let i = 0; i < kAr.length; i++) {
					for (let j = 0; j < returnObjList.length; j++) {
						let keyList = Object.keys(returnObjList[j]);
						if (keyList.indexOf(kAr[i]) < 0) {
							returnObjList[j][kAr[i]] = [];
							returnObjList[j][kAr[i]].push('');
						}
					}
				}

				return returnObjList;
			},
			removeMobile() {
				//사이즈별 테이블 삭제
				if (window.NodeList && !NodeList.prototype.forEach) {
					NodeList.prototype.forEach = Array.prototype.forEach;
				}

				// const removeElements = elms => elms.forEach(el => el.remove());
				const removeElements = elms => {
					elms.forEach(el => el.parentNode.removeChild(el));
				};
				if (window.innerWidth > 768) {
					removeElements(document.querySelectorAll('.web-hide'));
					removeElements(document.querySelectorAll('.web-hide-table'));
				} else {
					removeElements(document.querySelectorAll('.mobile-hide'));
				}
			},
		};
	},
};
